import React from "react";
import PropTypes from "prop-types";
import Region from "../../../../../models/Region";
import ClickTooltip from "../../../../../components/atoms/Tooltip/ClickTooltip";
import Btn from "../../../../../components/atoms/Btn";

function StructuralOverlay({ overlayData }) {
  const { allowCollapse, largeCount, toggleLimit, toggle } = overlayData;
  return (
    <div className="color-2 tw-pt-0.5 tw-text-xs tw-inset-0 tw-relative tw-mt-0.5 ">
      <div className="tw-absolute tw-inset-0 bg-1 tw-opacity-50" />
      <div className="tw-flex tw-items-center tw-px-16 tw-border-b tw-border-blueGray-500 tw-h-5">
        <div className="tw-mx-2 bg-1 tw-opacity-80">
          <div className="tw-pointer-events-auto tw-inline-block">
            {largeCount > 0 ? (
              <Btn
                className="tw-px-2 tw-rounded tw-text-sky-500 tw-font-bold"
                onSubmit={() => toggle()}
              >
                {allowCollapse ? "Expand" : "Collapse"}
              </Btn>
            ) : null}
          </div>
          <span className="tw-w-2" />
          <span className="tw-italic">
            {largeCount} variant
            {largeCount === 1 ? "" : "s"} with length over
          </span>
          <span className="tw-px-2 tw-font-bold tw-not-italic">
            {toggleLimit.toLocaleString()} bp
          </span>

          <span className="tw-pointer-events-auto tw-px-2">
            <ClickTooltip
              className="genome-browser-tooltip"
              zIndex={9999}
              ContentRenderer={() => (
                <div>
                  You can collapse large variants to reduce clutter.
                  <br />
                  You can change the limit in the filters.
                </div>
              )}
            >
              <div className="tw-cursor-pointer fa fa-question-circle tw-text-sky-400" />
            </ClickTooltip>
          </span>
        </div>
        <div className="tw-flex-grow" />
      </div>
    </div>
  );
}

StructuralOverlay.propTypes = {
  overlayData: PropTypes.shape({
    toggleLimit: PropTypes.number,
    allowCollapse: PropTypes.bool,
    toggle: PropTypes.func,
    largeCount: PropTypes.number,
    allVariants: PropTypes.arrayOf(
      PropTypes.shape({
        region: PropTypes.instanceOf(Region),
      })
    ),
  }).isRequired,
};

export default StructuralOverlay;
